import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import Faq from '../../Models/Faq';
import FaqCategory from '../../Models/FaqCategory';
import GetDictionaryResponse from '../Responses/DictionaryResponse';
import GetFaqCategoryResponse, { GetFaqCategoryTranslationsResponse } from '../Responses/FaqCategoryResponse';
import GetFaqResponse from '../Responses/FaqResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

class FaqCategoryApi extends AbstractCRMApi {
    public endpoint: string = 'faq_category';

    public getById(id: number): Promise<FaqCategory> {
        return this.get(`/${id}`).then((response: AxiosResponse<GetFaqCategoryResponse>) =>
            FaqCategoryApi.mapDataToFaqCategoryClass(response.data)
        );
    }

    public getAll(page: number = 1, config?: AxiosRequestConfig): Promise<GetPaginatedResponse<FaqCategory>> {
        return this.get('', {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetFaqCategoryResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, FaqCategory);
        });
    }

    public getAllWithoutPagination(config?: AxiosRequestConfig): Promise<FaqCategory[]> {
        return this.get('', {
            ...config,
            params: {
                ...config?.params,
                page: 0,
            },
        }).then((response: AxiosResponse<GetFaqCategoryResponse[]>) => {
            return response.data.map((item: GetFaqCategoryResponse) => new FaqCategory(item));
        });
    }

    public store(faqCategory: FaqCategory): Promise<FaqCategory> {
        return this.post('', faqCategory).then((response: AxiosResponse<GetFaqCategoryResponse>) =>
            FaqCategoryApi.mapDataToFaqCategoryClass(response.data)
        );
    }

    public update(faqCategory: FaqCategory): Promise<FaqCategory> {
        return this.patch(`/${faqCategory.id}`, faqCategory).then((response: AxiosResponse<GetFaqCategoryResponse>) =>
            FaqCategoryApi.mapDataToFaqCategoryClass(response.data)
        );
    }

    public getTranslations(): Promise<GetFaqCategoryTranslationsResponse> {
        return this.get('/translations').then(
            (response: AxiosResponse<GetFaqCategoryTranslationsResponse>) => response.data
        );
    }

    public getTranslatableNames(): Promise<GetDictionaryResponse> {
        return this.get('/translatable_names').then((response: AxiosResponse<GetDictionaryResponse>) => response.data);
    }

    public getFaqs(
        faqCategoryId: number,
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<Faq>> {
        return this.get(`/${faqCategoryId}/faqs`, {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetFaqResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, Faq);
        });
    }

    public getNotAddedFaqs(faqCategoryId: number, config?: AxiosRequestConfig): Promise<Faq[]> {
        return this.get(`/${faqCategoryId}/not_conected_faqs`, config).then(
            (response: AxiosResponse<Faq[]>) => response.data
        );
    }
}

export default new FaqCategoryApi();
